const { helpers } = require('@sstdev/lib_metadata-config');
const { getActionsAllowed } = helpers;
const Blockly = require('blockly');

const { BLOCK_CHANGE, BLOCK_CREATE, BLOCK_DELETE } = Blockly.Events;
const hasForAction = {};
module.exports = function addForActionDropdown(block, input) {
    const workspace = block.workspace;
    const hasForActionKey = block.id + '|' + block.workspace.id;
    if (workspace == null) {
        throw new Error('Block has no workspace');
    }
    const selectedNamespace = block.getFieldValue('namespace') || 'all';
    const selectedRelation = block.getFieldValue('relation') || 'all';
    const actionsAllowed = getActionsAllowed(selectedNamespace, selectedRelation);
    const whenNamespaceOrRelationChanges = function (event) {
        if (event.blockId === block.id) {
            if ([BLOCK_CHANGE, BLOCK_CREATE].includes(event.type)) {
                if (event.name === 'namespace') {
                    clearArray(actionsAllowed);
                    actionsAllowed.push(...getActionsAllowed(event.newValue));
                } else if (event.name === 'relation') {
                    clearArray(actionsAllowed);
                    const currentNamespace = block.getFieldValue('namespace');
                    actionsAllowed.push(...getActionsAllowed(currentNamespace, event.newValue));
                }
            } else if (event.type === BLOCK_DELETE) {
                workspace.removeChangeListener(whenNamespaceOrRelationChanges);
            }
        }
    };
    if (!workspace.listeners_.includes(whenNamespaceOrRelationChanges)) {
        workspace.addChangeListener(whenNamespaceOrRelationChanges);
    }
    const forActionVisible = input.fieldRow.some(field => field.name === 'forAction');
    if (!forActionVisible && !hasForAction[hasForActionKey]) {
        hasForAction[hasForActionKey] = true;
        const field = new Blockly.FieldDropdown(actionsAllowed);
        field.creationTime = Date.now();
        input.appendField('  For Action:').appendField(field, 'forAction');
        // Blockly doesn't really give us a great way to clean up if somebody just
        // blows away the input containing the field.  So we'll monkey patch dispose
        // on this instance so we can clean up when it is called.
        const holdDispose = field.dispose;
        field.dispose = function () {
            hasForAction[hasForActionKey] = false;
            workspace.removeChangeListener(whenNamespaceOrRelationChanges);
            holdDispose.call(field);
        };
    }
};

function clearArray(array) {
    while (array.length > 0) {
        array.pop();
    }
}
